import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPptDialog = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 62,
	viewBox: "0 0 64 62",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 30,
			cy: 30,
			r: 29.5,
			fill: "white",
			fillOpacity: .5,
			stroke: "#E88126"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 52.0925,
			cy: 49.1163,
			r: 10.907,
			fill: "#E88126",
			stroke: "white",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.75 16C20.2375 16 19.0138 17.2375 19.0138 18.75L19 40.75C19 42.2625 20.2237 43.5 21.7362 43.5H38.25C39.7625 43.5 41 42.2625 41 40.75V24.25L32.75 16H21.75ZM31.375 25.625V18.0625L38.9375 25.625H31.375Z",
			fill: "#E88126"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.9018 33.7696V36.2745H21.4369V29.1651H24.2104C24.7442 29.1651 25.213 29.2628 25.6166 29.4581C26.0235 29.6534 26.336 29.9317 26.5541 30.293C26.7722 30.6511 26.8813 31.0596 26.8813 31.5186C26.8813 32.2152 26.642 32.7654 26.1635 33.169C25.6882 33.5694 25.029 33.7696 24.1859 33.7696H22.9018ZM22.9018 32.5831H24.2104C24.5977 32.5831 24.8923 32.4919 25.0942 32.3096C25.2992 32.1273 25.4018 31.8669 25.4018 31.5284C25.4018 31.1801 25.2992 30.8985 25.0942 30.6837C24.8891 30.4688 24.6059 30.3581 24.2445 30.3516H22.9018V32.5831ZM29.3568 33.7696V36.2745H27.892V29.1651H30.6654C31.1993 29.1651 31.668 29.2628 32.0717 29.4581C32.4786 29.6534 32.7911 29.9317 33.0092 30.293C33.2273 30.6511 33.3363 31.0596 33.3363 31.5186C33.3363 32.2152 33.0971 32.7654 32.6186 33.169C32.1433 33.5694 31.4841 33.7696 30.641 33.7696H29.3568ZM29.3568 32.5831H30.6654C31.0528 32.5831 31.3474 32.4919 31.5492 32.3096C31.7543 32.1273 31.8568 31.8669 31.8568 31.5284C31.8568 31.1801 31.7543 30.8985 31.5492 30.6837C31.3442 30.4688 31.0609 30.3581 30.6996 30.3516H29.3568V32.5831ZM39.6986 30.3516H37.5209V36.2745H36.0561V30.3516H33.9076V29.1651H39.6986V30.3516Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M58 47.747H53.4797L55.3065 45.8669C53.4864 44.0667 50.5395 44.0001 48.7194 45.8002C46.8992 47.607 46.8992 50.5205 48.7194 52.3273C50.5395 54.1341 53.4864 54.1341 55.3065 52.3273C56.2132 51.4339 56.6666 50.3872 56.6666 49.0671H58C58 50.3872 57.4133 52.1006 56.2399 53.2607C53.8997 55.5809 50.0995 55.5809 47.7593 53.2607C45.4258 50.9472 45.4058 47.1869 47.746 44.8735C50.0861 42.56 53.8397 42.56 56.1799 44.8735L58 43V47.747ZM52.333 46.3336V49.1671L54.6664 50.5538L54.1864 51.3606L51.3329 49.6671V46.3336H52.333Z",
			fill: "white"
		})
	]
});
export default SvgPptDialog;
